import { get } from 'lodash';
import { reject, resolve } from 'redux-optimist-promise';
import { compareProposalsByComfort } from 'Utils/proposal/proposalUtils';
import { TRIP_INFORMATION_SET_DEPARTURE_CITY } from 'Store/trip-criteria/departure-city/constants';
import { TRIP_INFORMATION_SET_KIDS } from 'Store/trip-information/kids/constants';
import { TRIP_INFORMATION_SET_ADULTS_NUMBER } from 'Store/trip-information/adults/constants';
import { UPDATE_TRIP_DATE_CRITERIA } from 'Store/constants';
import { TRIP_INFORMATION_SET_DURATION } from 'Store/trip-criteria/duration/duration.constants';
import {
  ADD_ACCOMMODATION,
  ADD_ACCOMMODATION_FROM_ALTERNATIVES,
  CLEAR_PROPOSALS,
  FETCH_PROPOSALS,
  SET_PROPOSALS,
} from 'Store/booking/proposals/constants';
type State = string | null | undefined;
const initialState: State = null;
export default function bestProposalIdReducer(
  state: State = initialState,
  action: Action<any>,
): State {
  switch (action.type) {
    case resolve(FETCH_PROPOSALS): {
      const proposals = [...get(action, 'payload.proposals.proposals', [])].sort(
        compareProposalsByComfort,
      );
      return get(proposals, '[0].id', null);
    }

    case SET_PROPOSALS: {
      return get(action, 'payload.proposals[0].id', null);
    }

    case reject(FETCH_PROPOSALS):
    case resolve(ADD_ACCOMMODATION):
    case resolve(ADD_ACCOMMODATION_FROM_ALTERNATIVES):
    case CLEAR_PROPOSALS:
    case TRIP_INFORMATION_SET_DURATION:
    case TRIP_INFORMATION_SET_DEPARTURE_CITY:
    case TRIP_INFORMATION_SET_KIDS:
    case TRIP_INFORMATION_SET_ADULTS_NUMBER:
    case UPDATE_TRIP_DATE_CRITERIA: {
      return initialState;
    }

    default:
      return state;
  }
}
